module.exports = __webpack_public_path__ + "img/icon_backWhitePurple.a6781932.svg";